
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Zet het op je beginscherm voor een uitgebreide ervaring en gemakkelijke toegang.`,
's224cbcec014ef6b5': `Druk op delen in de navigatiebalk`,
's37a9e8aec5713460': `Meer`,
's386eca8362ff6155': `Druk op Meer als er geen Deel-icoon is`,
's4e1e10a6ca408245': `Tik op "Zet op beginscherm"`,
's6196153c4b0c1ea0': `Installeren`,
's633502f7cff4f847': `Open je browsermenu`,
's681e399d63311fba': `Galerij tonen`,
's7f0591f08e318eda': `Druk op Meer in het Deel-menu`,
's8114bd55cae5a22b': `Druk op Toevoegen aan Dock`,
's922329d6f6213590': `Toevoegen aan Dock`,
's9af56bf005b49c74': `Scrol omlaag en klik op "Zet op beginscherm"`,
'sa5ef80b4bb9b39f8': `Minder`,
'sba52286c21552a4e': `Installeer het op je apparaat voor een uitgebreide ervaring en gemakkelijke toegang.`,
'sc16e00a7a8b2fde2': `Terug`,
'scdaf4bbff76674c8': `Zet op beginscherm`,
'se0e473adfda8066c': `Open in je hoofdbrowser`,
'se740f75b95a51807': `Voeg het toe aan je Dock voor een uitgebreide ervaring en makkelijke toegang.`,
'sfea652f6580ff086': `Deze site heeft app-functionaliteit.`,
    };
  